import PublicHeader from "../components/PublicHeader";

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <PublicHeader />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight text-[#09090B] mb-8" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Mentions Légales
        </h1>

        <div className="space-y-8 text-sm text-zinc-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>1. Éditeur du site</h2>
            <p>Le site <strong>micromultimedia.fr</strong> est édité par :</p>
            <ul className="mt-2 space-y-1">
              <li><strong>Dénomination sociale :</strong> MICRO MULTIMÉDIA BERGEVIN</li>
              <li><strong>Forme juridique :</strong> SASU (Société par Actions Simplifiée Unipersonnelle)</li>
              <li><strong>Adresse :</strong> Super U de Bergevin, 97110 Pointe-à-Pitre, Guadeloupe</li>
              <li><strong>Téléphone :</strong> 05 90 89 56 35 (fixe) / 06 90 57 47 28 (mobile)</li>
              <li><strong>Email :</strong> <a href="mailto:micro.pc971@gmail.com" className="text-[#0055FF] hover:underline">micro.pc971@gmail.com</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>2. Directeur de la publication</h2>
            <p>Le directeur de la publication est le représentant légal de la société MICRO MULTIMÉDIA BERGEVIN.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>3. Hébergement</h2>
            <p>Le site est hébergé par :</p>
            <ul className="mt-2 space-y-1">
              <li><strong>Emergent (Emergent Labs Inc.)</strong></li>
              <li>Site : <a href="https://www.emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#0055FF] hover:underline">www.emergent.sh</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>4. Propriété intellectuelle</h2>
            <p>L'ensemble du contenu du site micromultimedia.fr (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de MICRO MULTIMÉDIA BERGEVIN, sauf mention contraire. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>5. Protection des données personnelles</h2>
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.</p>
            <p className="mt-2">Les données collectées sur ce site (nom, email, téléphone) sont utilisées uniquement dans le cadre de la gestion de votre compte client, du suivi SAV et du traitement de vos commandes. Elles ne sont en aucun cas cédées à des tiers.</p>
            <p className="mt-2">Pour exercer vos droits, contactez-nous à : <a href="mailto:micro.pc971@gmail.com" className="text-[#0055FF] hover:underline">micro.pc971@gmail.com</a></p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>6. Cookies</h2>
            <p>Le site utilise des cookies techniques nécessaires à son bon fonctionnement (authentification, session utilisateur). Aucun cookie publicitaire ou de traçage n'est utilisé.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>7. Limitation de responsabilité</h2>
            <p>MICRO MULTIMÉDIA BERGEVIN s'efforce de fournir des informations aussi précises que possible sur le site. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>8. Droit applicable</h2>
            <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux de Pointe-à-Pitre seront seuls compétents.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
